import React, { useState, useEffect } from 'react';
import apiService from '../../services/api.service';
import './Settings.css';

const Settings = () => {
    const [organization, setOrganization] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrganization = async () => {
            try {
                const response = await apiService.get('/organizations/me');
                if (response.success) {
                    setOrganization(response.data);
                } else {
                    setError(response.message || 'Failed to fetch organization details');
                }
            } catch (err) {
                setError(err.message || 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchOrganization();
    }, []);

    if (loading) return <div className="settings-loading">Loading settings...</div>;
    if (error) return <div className="settings-error">{error}</div>;

    return (
        <div className="settings-container">
            <div className="settings-header">
                <h1>Settings</h1>
                <p>Manage your organization and system preferences</p>
            </div>

            <div className="settings-section">
                <h2>Organization Details</h2>
                <div className="settings-card">
                    <div className="settings-field">
                        <label>Organization Name</label>
                        <div className="field-value">{organization?.name}</div>
                    </div>
                    <div className="settings-field">
                        <label>Organization ID</label>
                        <div className="field-value code-font">{organization?.id}</div>
                    </div>
                    <div className="settings-field">
                        <label>Created At</label>
                        <div className="field-value">{new Date(organization?.created_at).toLocaleString()}</div>
                    </div>
                </div>
            </div>

            <div className="settings-section">
                <h2>Administration</h2>
                <div className="settings-card">
                    <div className="settings-field">
                        <label>Organization Management</label>
                        <div className="field-value">
                            <a href="/settings/intake" className="settings-link">Open Organization Intake Form</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
